import { themeWorkspace } from "../theme-node";

export function init() {
  return {
    kind: "category",
    name_universal: "display",
    name: "%{BKY_CATDISPLAY}",
    colour: themeWorkspace.categoryStyles.start_category.colour,
    imageName: "/toolbox-imgs/bullhorn-solid.svg",
    id: "2",
    contents: [
      {
        kind: "label",
        text: "%{BKY_LABEL_START}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "info",
        fields: {
          default_title: "title",
          default_lang: "en",
          default_description: "",
          max_attempts: 1,
          default_feedback: false,
        },
      },
      {
        kind: "block",
        type: "statement",
      },
      {
        kind: "block",
        type: "display_element",
        inputs: {
          object: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_FORMATTING}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "richtext_create_with",
        extraState: { itemsCount: 3 },
        inputs: {
          ADD0: {
            block: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
          ADD1: {
            block: {
              type: "math_number",
              fields: {
                NUM: 123,
              },
            },
          },
          ADD2: {
            block: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "table_column",
        extraState: { itemsCount: 3 },
        inputs: {
          col_1: {
            block: {
              type: "text",
              fields: { TEXT: "abc" },
            },
          },
          col_2: {
            block: {
              type: "math_number",
              fields: { NUM: 123 },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_STYLES}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "set_alignment",
        fields: {
          alignment: "center",
        },
        inputs: {
          item: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "set_size",
        fields: {
          size: "xxx-large",
        },
        inputs: {
          item: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "set_colour",
        fields: {
          colour: "#3273dc",
        },
        inputs: {
          item: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "set_colour_random",
        inputs: {
          item: {
            shadow: {
              type: "text",
              fields: {
                TEXT: "abc",
              },
            },
          },
        },
      },
      {
        kind: "label",
        text: "%{BKY_LABEL_EXPERT}",
        "web-class": "myLabelStyle",
      },
      {
        kind: "block",
        type: "special_character",
        fields: {
          character: "br",
        },
      },
      {
        kind: "block",
        type: "markdown",
        inputs: {
          markdown: {
            shadow: {
              type: "text_multiline",
              fields: {
                TEXT: "text *italic* **bold**",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "latex",
        inputs: {
          LaTeX: {
            shadow: {
              type: "text_multiline",
              fields: {
                TEXT: "\\dfrac{a}{b}",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "latex_paragraph_create_with",
        extraState: { itemsCount: 3 },
        inputs: {
          ADD0: {
            block: {
              type: "text",
              fields: {
                TEXT: "y = ",
              },
            },
          },
          ADD1: {
            block: {
              type: "text",
              fields: {
                TEXT: "\\dfrac{a}{b}",
              },
            },
          },
          ADD2: {
            block: {
              type: "text",
              fields: {
                TEXT: "\\cdot x",
              },
            },
          },
        },
      },
      {
        kind: "block",
        type: "set_attribute",
        fields: {
          json: "{}",
        },
      },
      {
        kind: "block",
        type: "versions",
      },

      {
        kind: "block",
        type: "clean_activity",
      },
    ],
  };
}
